

<div>
  <b>Search Type:</b>
  <label><input type="radio" name="searchType" value="manual" [(ngModel)]="searchType" /> Manual</label>
  <label><input type="radio" name="searchType" value="ai" [(ngModel)]="searchType" /> AI</label>
  <br>
  <b>View Results As:</b>
  <label><input type="radio" name="resultType" value="objects" [(ngModel)]="showJson" [value]="false" /> Object Tree</label>
  <label><input type="radio" name="resultType" value="json" [(ngModel)]="showJson" [value]="true" /> JSON</label>
  <br>
  <span *ngIf="!showJson">
    <b>Format Object Tree:</b>
    <label><input type="radio" name="formatType" value="friendly" [(ngModel)]="showFriendly" [value]="true" /> Friendly</label>
    <label><input type="radio" name="formatType" value="admin" [(ngModel)]="showFriendly" [value]="false" /> Admin / Query</label>
  </span>
</div><br>

<div *ngIf="searchType === 'ai'">
  <label>Natural Language Query:</label><br><br>
  <input type="text" [(ngModel)]="naturalLanguageQuery" class="search-text-input" /> <br><br>
</div>
<div *ngIf="searchType === 'manual'">
  <label>Manual Query:</label><br><br>
  <textarea class="sql-text-input" [(ngModel)]="manualQuery" rows="10" cols="100"></textarea><br><br>
</div>

<button (click)="runSearch()">Search</button> <br><br>

<div *ngIf="isRunning">
  <p class="status-message loading">Loading...</p>
</div>

<div *ngIf="error">
  <h3 class="status-message error-heading">Error:</h3>
  <p>{{error}}</p>
</div>
<div *ngIf="!error && !isRunning && results && results.length > 0">
  <div *ngIf="showJson">
    <h3 class="results-heading">Search Results ({{results.length}}):</h3>
    <pre>{{results | json}}</pre>
  </div>
  <div *ngIf="!showJson">
    <h3 class="results-heading">Search Results ({{results.length}}):<span class="copy-icon" (click)="copyToClipboard(results)" title="Copy to clipboard">📋</span></h3>
    Filter: <input type="text" [(ngModel)]="filterText" class="search-text-input" /> <br><br>
    <div *ngFor="let item of (results)">
      <order-object-viewer [object]="item" [filterText]="filterText" [showFriendly]="showFriendly" [autoExpand]="results.length === 1"></order-object-viewer>
    </div>
  </div>
</div>